import script from "./AddContent.vue?vue&type=script&setup=true&lang=js"
export * from "./AddContent.vue?vue&type=script&setup=true&lang=js"

import "./AddContent.vue?vue&type=style&index=0&id=f60fe42a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f60fe42a"]])

export default __exports__